<mat-nav-list style="flex-grow: 1" [@leftTighten]="expanded()">
  <bci-sidebar-nav-item
    *ngFor="let navItem of parentNavItems(); last as isLast"
    [navItem]="navItem"
    [isLast]="isLast"
    [expandable]="!has3Levels()"
    [arrowRight]="
      (url == '/' && hasNavItems(navItem)) ||
      (has3Levels() && subNavItems().length === 0 && hasNavItems(navItem))
    "
    [tooltip]="tooltip(navItem) | async"
  >
  </bci-sidebar-nav-item>
</mat-nav-list>
<div *ngIf="has3Levels()" [@rightExpansion]="expanded()" class="second-layer">
  <mat-nav-list *ngIf="url != '/' && subNavItems().length > 0">
    <bci-sidebar-nav-item
      [navItem]="parentNavItem()"
      [showIcon]="false"
      [heading]="true"
    >
    </bci-sidebar-nav-item>
    <bci-sidebar-nav-item
      *ngFor="let navItem of subNavItems()"
      [navItem]="navItem"
      [showIcon]="true"
      [secondLevel]="hasNavItems(navItem)"
    >
    </bci-sidebar-nav-item>
  </mat-nav-list>
</div>
